module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1265.ae8ce807.png";